import React from 'react';

// Stroke icons on a 20×20 grid (stroke 1.6, round caps), drawn in currentColor.
const PATHS: Record<string, React.ReactNode> = {
  search: (
    <>
      <circle cx="9" cy="9" r="5.5" />
      <path d="M13.2 13.2L17 17" />
    </>
  ),
  chevronDown: <path d="M4.5 7.5l5.5 5.5 5.5-5.5" />,
  chevronLeft: <path d="M13 4.5L7.5 10l5.5 5.5" />,
  chevronRight: <path d="M7 4.5l5.5 5.5L7 15.5" />,
  plus: <path d="M10 4v12M4 10h12" />,
  close: <path d="M5 5l10 10M15 5L5 15" />,
  moreVertical: (
    <>
      <circle cx="10" cy="4" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="10" cy="10" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="10" cy="16" r="1.5" fill="currentColor" stroke="none" />
    </>
  ),
  moreHorizontal: (
    <>
      <circle cx="5" cy="10" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="10" cy="10" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="15" cy="10" r="1.5" fill="currentColor" stroke="none" />
    </>
  ),
  clock: (
    <>
      <circle cx="10" cy="10" r="7" />
      <path d="M10 6.5V10l2.5 2" />
    </>
  ),
  arrowRight: <path d="M4 10h12M11.5 5.5L16 10l-4.5 4.5" />,
  alert: (
    <>
      <circle cx="10" cy="10" r="7" />
      <path d="M10 6.5v4M10 13.5h.01" />
    </>
  ),
  check: <path d="M4.5 10.5l3.5 3.5 7.5-8" />,
  pin: (
    <>
      <path d="M10 17.5s-5.5-4.8-5.5-9a5.5 5.5 0 0 1 11 0c0 4.2-5.5 9-5.5 9z" />
      <circle cx="10" cy="8.5" r="2" />
    </>
  ),
  truck: (
    <>
      <path d="M2.5 5.5h9v8h-9zM11.5 8.5H15l2.5 2.5v2.5h-6" />
      <circle cx="6" cy="15" r="1.5" />
      <circle cx="14.5" cy="15" r="1.5" />
    </>
  ),
  sliders: (
    <>
      <path d="M3 6h14M3 10h14M3 14h14" />
      <circle cx="7" cy="6" r="1.6" fill="#FFFFFF" />
      <circle cx="13" cy="10" r="1.6" fill="#FFFFFF" />
      <circle cx="8.5" cy="14" r="1.6" fill="#FFFFFF" />
    </>
  ),
  print: (
    <>
      <path d="M5.5 8V3.5h9V8M5.5 14h-2v-6h13v6h-2" />
      <path d="M5.5 11.5h9v5h-9z" />
    </>
  ),
  download: <path d="M10 3.5v9M6 9l4 4 4-4M4 16.5h12" />,
  trash: <path d="M4.5 6h11M8 6V4h4v2M6 6l.7 10h6.6L14 6" />,
  undo: <path d="M7.5 6.5L4 10l3.5 3.5M4.5 10H12a4 4 0 0 1 0 8h-1.5" />,
  box: (
    <>
      <path d="M3 7l7-4 7 4v9l-7 4-7-4z" />
      <path d="M3 7l7 4 7-4M10 11v9" />
    </>
  ),
  copy: (
    <>
      <path d="M7.5 7.5h8v9h-8z" />
      <path d="M12.5 7.5v-4h-8v9h3" />
    </>
  ),
  inbox: (
    <>
      <path d="M3 11l2-6.5h10l2 6.5v4.5H3z" />
      <path d="M3 11h4l1 2h4l1-2h4" />
    </>
  ),
};

export type IconName = keyof typeof PATHS;

export const Icon: React.FC<{ name: IconName; size?: number; color?: string; style?: React.CSSProperties }> = ({ name, size = 16, color, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ flex: 'none', color, ...style }}
  >
    {PATHS[name]}
  </svg>
);
